let locationToggles = $('.location-label');

locationToggles.on('click', function(e) {

    let locationItem = $(this).parent('.location-item'),
        locationDetails = locationItem.find('.location-details');

    if(locationItem.hasClass('active')) {
        locationItem.removeClass('active');
        locationDetails.slideUp(200);
    } else {
        locationItem.addClass('active');
        locationDetails.slideDown(200);
    }

});
